









































































import { Component, Vue, Prop } from "vue-property-decorator";
import ChengduSettingDialog from "./chengduSettingDialog.vue";
@Component({
  components: {
    ChengduSettingDialog
  }
})
export default class ZiduanConfigDialog extends Vue {
  @Prop()
  private ziduan: any;
  @Prop()
  private dialogVisible: boolean | undefined;
  private bankZiduan: any = {};
  private tempZiduan: any = {
    name: "",
    type: "一般",
    setting: [
      {
        data: {
          name: "持续时间",
          options: ["小时", "天"],
          value: {
            unit: "天",
            持续时间: ""
          }
        },
        name: "是否显示持续时间",
        options: ["是", "否"],
        value: "否"
      },
      {
        data: {
          name: "发生频率",
          options: ["单次", "偶尔", "时常", "经常"],
          value: ""
        },
        name: "是否显示发生频率",
        options: ["是", "否"],
        value: "否"
      },
      {
        data: {
          name: "严重程度",
          options: ["轻", "中", "重"],
          value: ""
        },
        name: "是否显示发生频率",
        options: ["是", "否"],
        value: "否"
      }
    ],
    hide: false,
    value: "",
    system: false
  };
  private ifShowChengduSetting: any = false;
  private cZiduan: any = {};
  private dialogVisibleChange() {
    this.$emit("update:dialogVisible", this.dialogVisible);
  }
  /**
   * @description 关闭前回调
   */
  private handleClose() {
    this.$emit("update:dialogVisible", false);
  }
  /**
   * @description 新增一个字段
   */
  private addZiduan() {
    if (!this.tempZiduan.name) {
      this.$message.warning("字段名称必须填写");
      return;
    }
    this.tempZiduan.id = this.tempZiduan.name;
    this.ziduan.options.unshift(JSON.parse(JSON.stringify(this.tempZiduan)));
    this.tempZiduan = {
      name: "",
      type: "一般",
      setting: [
        {
          data: {
            name: "持续时间",
            options: ["小时", "天"],
            value: {
              unit: "天",
              持续时间: ""
            }
          },
          name: "是否显示持续时间",
          options: ["是", "否"],
          value: "否"
        },
        {
          data: {
            name: "发生频率",
            options: ["单次", "偶尔", "时常", "经常"],
            value: ""
          },
          name: "是否显示发生频率",
          options: ["是", "否"],
          value: "否"
        },
        {
          data: {
            name: "严重程度",
            options: ["轻", "中", "重"],
            value: ""
          },
          name: "是否显示发生频率",
          options: ["是", "否"],
          value: "否"
        }
      ],
      hide: false,
      value: "",
      system: false
    };
  }
  /**
   * @description 上移一位
   */
  private upThis(index) {
    if (index === 0) {
      return;
    }
    const temp: any = this.ziduan.options[index - 1];
    this.ziduan.options[index - 1] = this.ziduan.options[index];
    this.ziduan.options[index] = temp;
    this.$forceUpdate();
  }
  /**
   * @description 下移一位
   */
  private downThis(index) {
    if (index === this.ziduan.options.length - 1) {
      return;
    }
    const temp: any = this.ziduan.options[index + 1];
    this.ziduan.options[index + 1] = this.ziduan.options[index];
    this.ziduan.options[index] = temp;
    this.$forceUpdate();
  }
  /**
   * @description 删除自定义添加的字段
   */
  private deleteThis(index) {
    this.ziduan.options.splice(index, 1);
    this.$forceUpdate();
  }
  private setted(ziduan) {
    let count: any = 0;
    ziduan.setting.map((item: any) => {
      if (item.value === "是") {
        count++;
      }
    });
    if (count === 0) {
      return false;
    } else {
      return true;
    }
  }
  /**
   * @description 打开程度设置弹窗
   */
  private openChengduSetting(ziduan) {
    this.cZiduan = ziduan;
    this.ifShowChengduSetting = true;
  }
  /**
   * @description 取消设定
   */
  private cancelSetting(ziduan) {
    ziduan.setting.map((item: any) => {
      item.value = "否";
    });
  }
  /**
   * @description 取消
   */
  private cancel() {
    this.ziduan.options = this.bankZiduan.options;
    this.$emit("update:dialogVisible", false);
  }
  /**
   * @description 确定
   */
  private confirm() {
    this.$emit("update:dialogVisible", false);
  }
  private mounted() {
    this.bankZiduan = JSON.parse(JSON.stringify(this.ziduan));
  }
}
